import { buildBaseUrl, teamAppUrl } from "lib/utils";
import getConfig from 'next/config';
import axios from 'axios';
import { decryptSessionKeyWithPassword, encryptSessionKey, expand } from "lib/e2ee/helper";
import * as openpgp from 'openpgp';
import { useCookies } from "react-cookie";

const { publicRuntimeConfig: { genericRESTUrl, baseDomain }} = getConfig();

export const useLastVisitedShare = () => {
  const [cookies, _, removeCookie] = useCookies(['packs_last_visited_share']);

  const join = async (identifier: string, publicKeyArmored: string) => {
    const teamUrl = teamAppUrl(identifier);

    const lastVisitedShare = cookies.packs_last_visited_share;

    if (!lastVisitedShare || !lastVisitedShare.includes('#')) return;
  
    const [ packId, password ] = lastVisitedShare.split('#');
  
    const getPackUrl = buildBaseUrl(teamUrl, `${genericRESTUrl}/v1/packs/${packId}`);
    const { data: pack } = await axios.get(getPackUrl, { withCredentials: true });
  
    if (!pack.is_joinable) {
        return removeCookie('packs_last_visited_share', { path: '/', domain: baseDomain});
    }

    const data = {} as any;
  
    if (pack.key) {
        if (!password.length) {
            return removeCookie('packs_last_visited_share', { path: '/', domain: baseDomain});
        }
        else {
            const publicKey = await openpgp.readKey({ armoredKey: expand(publicKeyArmored) });
            const packKey = await decryptSessionKeyWithPassword(pack.key, password);
            data.key = await encryptSessionKey(packKey, publicKey, password);
        }
    }
  
    const joinPackUrl = buildBaseUrl(teamUrl, `${genericRESTUrl}/v1/packs/${packId}/join`);
    await axios.post(joinPackUrl, data, { withCredentials: true });

    removeCookie('packs_last_visited_share', { path: '/', domain: baseDomain});
  }

  return { join };
}